import { render } from "./edit-syllabus.vue?vue&type=template&id=0769f9b0"
import script from "./edit-syllabus.vue?vue&type=script&lang=js"
export * from "./edit-syllabus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__